import { validateName } from "@qoohoo/common/utils/validators";

export function validateUserFullname(formData) {
  const { user_fullname } = formData;
  if (!user_fullname) {
    return { user_fullname: "Please enter a name" };
  }
  if (user_fullname.length < 2) {
    return { user_fullname: "Name should be more than 2 characters" };
  }
  if (!validateName(user_fullname)) {
    return { user_fullname: "Please enter a valid name" };
  }
  return null;
}

export function validateUserCountry(formData) {
  const { user_country } = formData;
  if (!user_country) {
    return { user_country: "Please select a country" };
  }
  return null;
}
